module.exports = __webpack_public_path__ + "media/src/images/icon__sad--2--dark-4d08eaaf5dc2d1eefe03487f55d5b1c9.png";